<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container">
    <div class="row">
      <div class="col-sm-8 offset-sm-2 text-center mb-3">
        <h5 class="mt-4" [ngClass]="{'page-title': useRebrandedLayout }">
          Please submit your email and set a password below to create your pet’s
          microchip account
        </h5>
      </div>

      <div class="col-12">
        <ngb-alert
          *ngIf="alert"
          [type]="alert.type"
          (closed)="closeAlert()"
          class="sticky-top"
          style="top: 10px"
          >{{ alert.message }}</ngb-alert
        >

        <form
          #passwordForm="ngForm"
          (ngSubmit)="claimAccount()"
          [appMatchingFields]="['password', 'passwordConfirm']"
          novalidate
        >
        <div [ngClass]="{'form-card h-100 p-4': useRebrandedLayout}">
          <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-4 offset-lg-2 offset-md-0">
              <div class="mb-3">
                <div>
                  <label class="form-label" for="email"> Email address </label>
                </div>
                <div>
                  <mat-form-field appearance="outline" class="w-100">
                    <input
                      [class.is-invalid]="email.touched && !email.valid"
                      [emailDot]="true"
                      id="email"
                      name="email"
                      [(ngModel)]="model.newEmailAddress"
                      placeholder="Email address"
                      type="email"
                      matInput
                      #email="ngModel"
                      required
                    />
                    <!--This next div is needed to make the input high enough-->
                    <div class="dummy-div" matSuffix></div>
                    <mat-error
                      *ngIf="
                        (email.errors && email.errors.required) ||
                        (email.errors && email.errors.email)
                      "
                    >
                      {{
                        email.errors && email.errors.required
                          ? errorStrings.required
                          : errorStrings.emailInvalid
                      }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="mb-3">
                <div>
                  <label class="form-label" for="password"> Password </label>
                </div>
                <div>
                  <mat-form-field appearance="outline" class="w-100">
                    <input
                      matInput
                      #password="ngModel"
                      [type]="hidePassword ? 'password' : 'text'"
                      [class.is-invalid]="password.touched && !password.valid"
                      id="password"
                      name="password"
                      [(ngModel)]="model.password"
                      placeholder="Password"
                      required
                      passwordStrength
                    />
                    <button
                      type="button"
                      mat-icon-button
                      matSuffix
                      (click)="hidePassword = !hidePassword"
                      [attr.aria-label]="'Hide password'"
                      [attr.aria-pressed]="hidePassword"
                    >
                      <mat-icon>{{
                        hidePassword ? "visibility_off" : "visibility"
                      }}</mat-icon>
                    </button>
                    <mat-error
                      *ngIf="
                        (password.errors && password.errors.minlength) ||
                        (password.errors && password.errors.required)
                      "
                    >
                      {{
                        password.errors && password.errors.minlength
                          ? errorStrings.passwordTooShort
                          : errorStrings.required
                      }}
                    </mat-error>
                  </mat-form-field>
                  <app-zxcvbn-password-strength [password]="model.password" [control]="password" />
                </div>
              </div>

              <div class="mb-3">
                <div>
                  <label class="form-label" for="passwordConfirm"> Confirm password </label>
                </div>
                <div>
                  <mat-form-field appearance="outline" class="w-100">
                    <input
                      matInput
                      #passwordConfirm="ngModel"
                      [type]="hideConfirmPassword ? 'password' : 'text'"
                      [class.is-invalid]="
                        passwordConfirm.touched && !passwordConfirm.valid
                      "
                      id="passwordConfirm"
                      minlength="8"
                      name="passwordConfirm"
                      ngModel=""
                      placeholder="Confirm password"
                      required
                    />
                    <button
                      mat-icon-button
                      type="button"
                      matSuffix
                      (click)="hideConfirmPassword = !hideConfirmPassword"
                      [attr.aria-label]="'Hide password'"
                      [attr.aria-pressed]="hideConfirmPassword"
                    >
                      <mat-icon>{{
                        hideConfirmPassword ? "visibility_off" : "visibility"
                      }}</mat-icon>
                    </button>
                    <mat-error
                      *ngIf="
                        (passwordConfirm.errors &&
                          passwordConfirm.errors.required) ||
                        (passwordConfirm.errors &&
                          passwordConfirm.errors.minlength) ||
                        (passwordConfirm.errors &&
                          passwordConfirm.errors.matchingFields)
                      "
                    >
                      {{
                        passwordConfirm.errors && passwordConfirm.errors.required
                          ? errorStrings.required
                          : passwordConfirm.errors &&
                            passwordConfirm.errors.minlength
                          ? errorStrings.passwordTooShort
                          : errorStrings.passwordMismatch
                      }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 mt-4">
              <div class="fw-bold account-description-wrapper">
                <div>What can you do with your account</div>
                <ul>
                  <li>Update your contact details</li>
                  <li>Confirmation of your pet(s) details</li>
                  <li>Choose your level of pet protection</li>
                  <li>Access to other services and pet related offers</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
          <div class="row">
            <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-4 mb-3">
              <button
                type="submit"
                class="btn btn-success text-white btn-lg w-100 mt-5 mb-5"
                [disabled]="!passwordForm.valid || loading"
              >
                <fa-icon
                  *ngIf="loading"
                  [icon]="['fas', 'spinner']"
                  [animation]="'spin'"
                  class="me-3"
                ></fa-icon>
                {{ loading ? "Submit..." : "Submit" }}
                <fa-icon [icon]="['fas', 'chevron-right']" class="ms-2"></fa-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
